import React from 'react';

import ImageSection from '../shared/ImageSection';

type Props = {
  image: string;
};

export const BenefitsImage: React.FC<Props> = ({ image }) => {
  return <ImageSection image={image} data-testid='mp-product-benefits-image' />;
};
